export default "__VITE_ASSET__DaAe8jSh__"